import script from "./InfoSessionHours.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSessionHours.vue?vue&type=script&setup=true&lang=js"

import "./InfoSessionHours.vue?vue&type=style&index=0&id=40dbece6&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40dbece6"]])

export default __exports__